import React, { useEffect, useState } from "react";
import "./comments.scss";
import { fetchImage, getFullName } from "../../utils/common";
import StarRating from "../rating/StarRating";
import UserImg from '../../assets/images/providerProfileImg.png'
const formatDate = (dateString) => {
  const options = { year: "numeric", month: "long" };
  return new Date(dateString).toLocaleDateString(undefined, options);
};

const Comments = (props) => {
  const [profilePics, setProfilePics] = useState({}); // Store resolved image URLs

  useEffect(() => {
    const loadImages = async () => {
      let images = {};
      await Promise.all(
        props?.rating?.map(async (item) => {
          const reviewer = item?.userId;
          if (reviewer?.profilePic) {
            try {
              images[reviewer._id] = await fetchImage(reviewer.profilePic);
            } catch (error) {
              console.error("Error loading image:", error);
              images[reviewer._id] = UserImg; // Fallback to default image on error
            }
          } else {
            images[reviewer._id] = UserImg; // Default if no profilePic
          }
        })
      );
      setProfilePics(images);
    };

    if (props?.rating?.length) {
      loadImages();
    }
  }, [props?.rating]);

  return (
    <>
      <div className="comments-wrapper w-100">
        {props?.rating?.map((item, index) => {
          const reviewer = item?.userId;
          const profilePic = profilePics[reviewer?._id] || UserImg; // Get resolved image

          return (
            <div className="comment-row" key={index}>
              <div className="comment-detail-wrap">
                <div className="comment-user-wrap">
                  <div className="comment-user-pic">
                    <img src={profilePic} alt="User" />
                  </div>
                  <div className="comment-user-detail">
                    <div className="comment-user-name-wrap">
                      {getFullName(reviewer?.firstName, reviewer?.lastName) || "Anonymous"}
                    </div>
                    <div className="comment-date">{formatDate(item?.updatedAt)}</div>
                  </div>
                </div>
                <div className="comment-rating-wrap">
                  <div className="rating">
                    <StarRating size={14} rating={item?.providerRating} />
                  </div>
                  <div className="rating-value">({item?.providerRating ?? 0})</div>
                </div>
              </div>
              <div className="comment-description">{item?.providerReview}</div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Comments;
